import * as v from 'valibot'
import Holidays from 'date-holidays'
import dayjs from "dayjs";
import dayjs_utc from 'dayjs/plugin/utc'
import dayjs_tz from 'dayjs/plugin/timezone'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
dayjs.extend(dayjs_utc)
dayjs.extend(dayjs_tz)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)


/**
 * Check if a string is in a valid YYYY-MM-DD format
 *
 * @param {string} ymd_string
 * @returns boolean true if the input value is a valid YYYY-MM-DD formatted string
 */
export function isValidYMDstring(ymd_string) {
	const validation = v.safeParse(v.pipe(v.string(), v.isoDate()), ymd_string)

	return validation.success && Number.isNaN(Date.parse(ymd_string)) === false
}

/**
 * Return the year, month, and day components of a "YYYY-MM-DD" formatted string
 *
 * @param {string} date_str
 * @returns an object with "year", "month", "day" string properties or null if the input value cannot be parsed
 */
export function getYMDstringParts(date_str) {
	if (!isValidYMDstring(date_str)) {
		return null
	}

	const [year, month, day] = date_str.split('-')

	return { year, month, day }
}

export function isPublicUSHoliday(date: Date) {

	if (!date) return false

	const hd = new Holidays('US')

	// hd.isHoliday(date) reads the local calendar day off the Date object, but that day shifts
	// depending on the runtime's timezone relative to the holiday data's own internal timezone,
	// so callers building Date objects at UTC midnight (e.g. the cally calendar) can get a
	// mismatched day. Compare by YYYY-MM-DD string instead, which sidesteps both timezones.
	const target_ymd = date.toISOString().split('T')[0]
	const holidays_for_year = hd.getHolidays(date.getUTCFullYear())

	return holidays_for_year.some(h => h.type === 'public' && dayjs(h.date).format('YYYY-MM-DD') === target_ymd)
}

export function isDateRangeCoversDateRange(
	covering_date_range: {date_start: string | undefined, date_end: string | undefined},
	base_date_range: {date_start: string | undefined, date_end: string | undefined},
) {

	const covering_date_start = (!covering_date_range.date_start || covering_date_range.date_start === '-infinity' || covering_date_range.date_start === 'infinity') ? undefined : dayjs(covering_date_range.date_start)
	const covering_date_end = (!covering_date_range.date_end || covering_date_range.date_end === 'infinity' || covering_date_range.date_end === '-infinity') ? undefined : dayjs(covering_date_range.date_end)
	const date_start = (!base_date_range.date_start || base_date_range.date_start === '-infinity' || base_date_range.date_start === 'infinity') ? undefined : dayjs(base_date_range.date_start)
	const date_end = (!base_date_range.date_end || base_date_range.date_end === 'infinity' || base_date_range.date_end === '-infinity') ? undefined : dayjs(base_date_range.date_end)

	// console.log(
	// 	'COVERS??',
	// 	covering_date_start?.format('MM/DD/YYYY'),
	// 	covering_date_end?.format('MM/DD/YYYY'),
	// 	date_start?.format('MM/DD/YYYY'),
	// 	date_end?.format('MM/DD/YYYY'),
	// 	(!date_start && !date_end) && 'A',
	// 	(!covering_date_start && !covering_date_end) && 'B',
	// 	(!date_start && date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_end)
	// 			&& covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_end)
	// 		)
	// 	)) && 'C',
	// 	(date_start && !date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 			&& covering_date_end.isSameOrAfter(date_start)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_start)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 		)
	// 	)) && 'D',
	// 	(date_start && date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 			&& covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 		)
	// 	)) && 'E',
	// 	!((!date_start && !date_end)
	// 	|| (!covering_date_start && !covering_date_end)
	// 	|| (!date_start && date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_end)
	// 			&& covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_end)
	// 		)
	// 	))
	// 	|| (date_start && !date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 			&& covering_date_end.isSameOrAfter(date_start)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_start)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 		)
	// 	))
	// 	|| (date_start && date_end && (
	// 		covering_date_start && covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 			&& covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| !covering_date_start && covering_date_end && (
	// 			covering_date_end.isSameOrAfter(date_end)
	// 		)
	// 		|| covering_date_start && !covering_date_end && (
	// 			covering_date_start.isSameOrBefore(date_start)
	// 		)
	// 	))) && 'F!!!!',
	// )

	return (!date_start && !date_end)
	|| (!covering_date_start && !covering_date_end)
	|| (!date_start && date_end && (
		covering_date_start && covering_date_end && (
			covering_date_start.isSameOrBefore(date_end)
			&& covering_date_end.isSameOrAfter(date_end)
		)
		|| !covering_date_start && covering_date_end && (
			covering_date_end.isSameOrAfter(date_end)
		)
		|| covering_date_start && !covering_date_end && (
			covering_date_start.isSameOrBefore(date_end)
		)
	))
	|| (date_start && !date_end && (
		covering_date_start && covering_date_end && (
			covering_date_start.isSameOrBefore(date_start)
			&& covering_date_end.isSameOrAfter(date_start)
		)
		|| !covering_date_start && covering_date_end && (
			covering_date_end.isSameOrAfter(date_start)
		)
		|| covering_date_start && !covering_date_end && (
			covering_date_start.isSameOrBefore(date_start)
		)
	))
	|| (date_start && date_end && (
		covering_date_start && covering_date_end && (
			covering_date_start.isSameOrBefore(date_start)
			&& covering_date_end.isSameOrAfter(date_end)
		)
		|| !covering_date_start && covering_date_end && (
			covering_date_end.isSameOrAfter(date_end)
		)
		|| covering_date_start && !covering_date_end && (
			covering_date_start.isSameOrBefore(date_start)
		)
	))
}
